import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerSiteComponent } from './customer-site.component';
import {CustomerSiteRoutingModule} from './customer-site.routing.module';
import {SharedModule} from '../../theme/shared/shared.module';
import {NgbCarouselModule, NgbProgressbarModule, NgbTabsetModule} from '@ng-bootstrap/ng-bootstrap';
import {TableModule} from 'primeng/table';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {ToastModule} from 'primeng/toast';
import {CalendarModule} from 'primeng/calendar';
import {InputSwitchModule} from 'primeng/inputswitch';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';
import {TooltipModule} from 'primeng/tooltip';
import {AddEditCustomerSiteComponent} from './add-edit-customer-site/add-edit-customer-site.component';
@NgModule({
  declarations: [CustomerSiteComponent,AddEditCustomerSiteComponent],
  imports: [
    CommonModule,
    SharedModule,
    NgbProgressbarModule,
    NgbTabsetModule,
    CustomerSiteRoutingModule,
    ToastModule,
    TableModule,
    TooltipModule,
    InputSwitchModule,
    DynamicDialogModule,
    ConfirmDialogModule,
    MessageModule,
    MessagesModule,
    NgbCarouselModule,
    DropdownModule,
    CalendarModule
  ],
  exports:[AddEditCustomerSiteComponent]
})
export class CustomerSiteModule { }
